<app-belak-coming-soon *ngIf="showComingSoon"></app-belak-coming-soon>
<ng-container *ngIf="!showComingSoon">
<div class="page-wrapper" [class.shift-right]="isSidebarOpen">
  <div class="" #routerOutletRef>
    <app-header [headerSettings]="headerSettings"></app-header>
  </div>
  <!-- Content area: no artificial min-height — real content fills the space -->
  <div class="router-outlet-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
<!-- CRITICAL FIX: Always render footer structure immediately, just defer data loading -->
<!-- This prevents layout shift where footer appears on top before content loads -->
<app-footer [footerSettings]="footerSettings"></app-footer>
<app-scroll-up-btn />
</ng-container>